import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Text, YStack } from "tamagui";
import { RiInformationLine } from "react-icons/ri";
import { colors } from "@styles/colors";

/**
 * 客戶在一卡通授權頁按取消時導回這裡（流程 C 的橘色分支）。
 *
 * 訂單此時還是草稿狀態，沒有 regKey 也就扣不了款——引導客戶改選其他付款方式，
 * 不要讓他停在一個看不懂的空白頁。
 */
export default function IPassCancel() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const orderId = params.get("orderId") || "";

  return (
    <YStack f={1} ai="center" jc="center" gap={16} p="$4" background={colors.bg}>
      <RiInformationLine size={64} color={colors.sub} />
      <Text fontSize={20} fontWeight="700" color={colors.text}>
        已取消授權
      </Text>
      <Text fontSize={14} color={colors.sub} ta="center">
        您取消了 iPASS Money 的自動扣款授權，訂單尚未送出。
        您可以改選貨到付款或其他付款方式後再送出訂單。
      </Text>
      {!!orderId && (
        <Text fontSize={12} color={colors.sub}>
          訂單：{orderId}
        </Text>
      )}
      <Button width="100%" backgroundColor={colors.primary} color="#fff" onPress={() => navigate("/gasShop/cart")}>
        回去改付款方式
      </Button>
    </YStack>
  );
}
